<template>
  <seats-modal-shell
    :visible="true"
    title="Transferir a licença"
    :busy="isSubmitting"
    @close="$emit('close')">
    <div v-if="succeeded">
      <p class="seats-modal-success">{{ receiverName }} agora ocupa a licença {{ transferFrom.seat.plan }}, sem cobrança nova.</p>
      <div class="seats-modal-footer">
        <button type="button" class="seats-modal-button seats-modal-button--primary" @click="$emit('close')">Entendido</button>
      </div>
    </div>

    <div v-else>
      <p v-if="senderAlreadyDeactivated" class="seats-modal-text">
        {{ transferFrom.name }} foi desativado. A licença {{ transferFrom.seat.plan }} dele está livre e pode ser transferida para outra pessoa, sem cobrança nova.
      </p>
      <p v-else class="seats-modal-text">
        {{ transferFrom.name }} será desativado e perderá o acesso. A licença {{ transferFrom.seat.plan }} dele será transferida para a pessoa escolhida, sem cobrança nova.
      </p>

      <label class="seats-modal-label" for="transfer-seat-user">Transferir para</label>
      <p v-if="receiverCandidates.length === 0" class="seats-modal-text">
        Não há usuários desativados ou aguardando pagamento. Convide o usuário antes de transferir a licença para ele.
      </p>
      <select
        v-else
        id="transfer-seat-user"
        v-model="selectedEmail"
        class="seats-modal-select"
        :disabled="isSubmitting || (senderDeactivated && !senderAlreadyDeactivated)">
        <option value="" disabled>Selecione o usuário</option>
        <option v-for="candidate in receiverCandidates" :key="candidate.email" :value="candidate.email">
          {{ candidate.name }} ({{ candidate.email }}){{ candidate.isAwaitingPayment ? ' · aguardando pagamento' : '' }}
        </option>
      </select>
      <p v-if="selectedCandidate && selectedCandidate.isAwaitingPayment" class="seats-modal-warning">
        O convite pendente dele será cancelado.
      </p>

      <div v-if="senderDeactivated && !senderAlreadyDeactivated && error" class="seats-modal-error">
        {{ transferFrom.name }} já foi desativado e a licença dele ficou livre, mas não foi possível colocar {{ receiverName }} nela. {{ error }}
      </div>
      <p v-else-if="error" class="seats-modal-error">{{ error }}</p>

      <div class="seats-modal-footer">
        <button type="button" class="seats-modal-button seats-modal-button--secondary" :disabled="isSubmitting" @click="$emit('close')">
          {{ senderDeactivated ? 'Fechar' : 'Cancelar' }}
        </button>
        <button
          type="button"
          class="seats-modal-button seats-modal-button--primary"
          :disabled="submitBlocked"
          @click="submit">
          {{ submitLabel }}
        </button>
      </div>
    </div>
  </seats-modal-shell>
</template>

<script>
import loopback from '@/services/loopback'
import { occupySeat } from '@/services/subscription'
import { friendlyPlainText } from '@/utils/error-message'
import SeatsModalShell from './SeatsModalShell.vue'

export default {
  name: 'TransferSeatModal',
  components: {
    SeatsModalShell
  },
  props: {
    candidates: {
      type: Array,
      required: true
    },
    transferFrom: {
      type: Object,
      required: true
    },
    // Atalho depois de desativar: quem saiu já está inativo e a licença dele, livre.
    senderAlreadyDeactivated: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedEmail: '',
      isSubmitting: false,
      senderDeactivated: this.senderAlreadyDeactivated,
      succeeded: false,
      receiverName: '',
      error: ''
    }
  },
  computed: {
    // Quem saiu também está desativado, mas não recebe a própria licença de volta.
    receiverCandidates () {
      return this.candidates.filter(user => user.email !== this.transferFrom.email)
    },
    selectedCandidate () {
      const candidate = this.receiverCandidates.find(user => user.email === this.selectedEmail)
      return candidate === undefined ? null : candidate
    },
    submitBlocked () {
      return this.isSubmitting || this.selectedCandidate === null
    },
    submitLabel () {
      if (this.isSubmitting) return 'Salvando...'
      if (this.senderAlreadyDeactivated) return 'Transferir a licença'
      if (this.senderDeactivated) return 'Tentar ocupar de novo'
      return 'Desativar e transferir a licença'
    }
  },
  methods: {
    async submit () {
      if (this.submitBlocked) return
      this.isSubmitting = true
      this.error = ''
      this.receiverName = this.selectedCandidate.name
      try {
        if (!this.senderDeactivated) {
          await loopback.patch('/users', { email: this.transferFrom.email, status: 'INACTIVE' })
          this.senderDeactivated = true
        }
        await occupySeat(this.selectedEmail, this.transferFrom.seat.seatId)
        this.succeeded = true
      } catch (err) {
        this.error = friendlyPlainText(err, 'Não foi possível transferir a licença. Tente novamente.')
      } finally {
        this.isSubmitting = false
        this.$emit('refresh')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Users/seats/TransferSeatModal.vue